/* eslint-disable import/prefer-default-export */
import types from 'redux/actions/actionTypes';

export function setModal(modal) {
  return { type: types.SET_MODAL, modal };
}
